"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Checkout =
/** @class */
function () {
  function Checkout() {
    this.requirements = {};
    this.product = {};
    this.context = {};
  }

  Checkout.prototype.getContext = function (name) {
    return this.context[name];
  };

  Checkout.prototype.setContext = function (name, value) {
    this.context[name] = value;
  };

  Checkout.prototype.addProduct = function (product) {
    this.product = product;
  };

  Checkout.prototype.addRequirement = function (requirement) {
    this.requirements[requirement.name] = requirement;
  };

  Checkout.prototype.getData = function () {
    var data = {};

    for (var name_1 in this.requirements) {
      data[name_1] = this.requirements[name_1].data;
    }

    return data;
  };

  Checkout.prototype.fulfillRequirement = function (name, data) {
    if (data === void 0) {
      data = null;
    }

    var requirement = this.requirements[name];

    if (!requirement) {
      throw new Error("requirement with name: " + name + " does not exist");
    }

    requirement.fulfill(data);
  };

  return Checkout;
}();

exports.default = Checkout;